// extracted by mini-css-extract-plugin
export var component = "TextModule-module--component--LetOM";
export var content = "TextModule-module--content--c6pZs";
export var title = "TextModule-module--title--plxCx";